import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
import Tree from "vue3-treeview";
import swal from "../../../_helpers/swal";
import ApiService from "@/_services/api.service";

// variables
interface ITreeConfig {
    roots: string[];
    checkboxes: boolean;
    checkMode: string;
    dragAndDrop: boolean;
    editable: boolean;
}

interface ITreeNodeState {
    opened: boolean;
    disabled: boolean;
    checked: boolean;
}

interface INodes {
    [id: string]: INode;
}

interface INode {
    categoryUuid: string
    text: string;
    children?: string[];
    state?: ITreeNodeState | null;
}

interface ICategory {
    id: string;
    uuid: string;
    text: string;
    state?: ITreeNodeState | null;
    children?: [] | ICategory[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryProductList',
  setup(__props) {

// IMPORTS
const nodes = ref<INodes>({});
const TreeConfig = ref<ITreeConfig>({
    roots: [],
    checkboxes: true,
    checkMode: "manual",
    dragAndDrop: false,
    editable: false,
});
const isLoadingCategories = ref<boolean>(true);
const categoriesLevel1 = ref(Array<ICategory>());
const categoriesAndChildren = ref(Array<ICategory>());
const selectedCategoriesUuids = ref(Array<string>());

// Interfaces
onMounted(() => {
    fetchCategoriesData();
});

// functions
async function fetchCategoriesData() {
    await ApiService.get("categories", {
        params: { lvl: 1, "order[lft]": "ASC" },
    })
    .then(async ({ data }) => {
        if (data.data.length > 0) {
            data.data.forEach((category, index: number) => {
                let id = index.toString();
                let newCategory: ICategory = {
                    id: id,
                    uuid: category.uuid,
                    text: category.name,
                    children: formatChildrenToCategory(category.children, id),
                };
                categoriesLevel1.value.push(newCategory);
                categoriesAndChildren.value.push(newCategory);
            });
            hydrateCategoriesTreeview();
        }
    })
    .catch(() => {
        swal.error("Une erreur a été détectée, veuillez re essayer 2");
        return false;
    });
    isLoadingCategories.value = false;
}

function formatChildrenToCategory(data, parentKey: string) {
    let childrenData = Array<ICategory>();
    data.forEach((item, index: number) => {
        let key = parentKey + "-" + index;
        let newCategory: ICategory = {
            id: key,
            uuid: item.uuid,
            text: item.name,
            children:
                item.children && item.children.length
                ? formatChildrenToCategory(item.children, key)
                : [],
        };
        childrenData.push(newCategory);
        categoriesAndChildren.value.push(newCategory);
    });

    return childrenData;
}

function hydrateCategoriesTreeview() {
    // Define Categories Roots Level 1 Ids
    categoriesLevel1.value.forEach((category: ICategory) => {
        TreeConfig.value.roots.push(category.id);
    });

    // Define Categories and Children
    categoriesAndChildren.value.forEach((category: ICategory) => {
        const categoryNode: INode = {
            text: category.text,
            categoryUuid: category.uuid,
            children: category.children && category.children.length > 0
                ? getCategoryChildrenIds(category.children)
                : []
        };

        nodes.value[category.id] = categoryNode;
    });
}

function getCategoryChildrenIds(categories: ICategory[]): string[]|[] {
    let categoryChildrenIds: string[] = [];
    categories.forEach((item: ICategory) => {
        categoryChildrenIds.push(item.id);
    });

    return categoryChildrenIds;
}

function onCategoryNodeChecked(event) {
    let categoryUuid = event.categoryUuid;
    if (!selectedCategoriesUuids.value.includes(categoryUuid)) {
        selectedCategoriesUuids.value.push(categoryUuid);
    }
}

function onCategoryNodeUnchecked(event) {
    let categoryUuid = event.categoryUuid;
    selectedCategoriesUuids.value = selectedCategoriesUuids.value.filter(uuid => uuid !== categoryUuid);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Tree), {
      nodes: nodes.value,
      config: TreeConfig.value,
      onNodeChecked: _cache[0] || (_cache[0] = ($event: any) => (onCategoryNodeChecked($event))),
      onNodeUnchecked: _cache[1] || (_cache[1] = ($event: any) => (onCategoryNodeUnchecked($event)))
    }, null, 8, ["nodes", "config"])
  ]))
}
}

})